import { SsoType } from '@app-types/sso'
import { URLS } from '@components/onboarding/urls'
import { RedirectError } from '@lib/errors/PageError'
import { useEffectAsync } from '@lib/hooks/useEffectAsync'
import { useNavigation } from '@lib/hooks/useNavigation'
import { useSession } from '@lib/store/useStores'
import type { PageWithContext } from '@lib/utils/context'
import { OtpVerificationStatus } from '@lib/utils/login'
import { PAGE_OPTIONS } from '@lib/utils/page'
import { getAuthLayout } from '@page-templates/auth-page'
import { PageTemplate } from '@page-templates/generic-page'
import { LINK } from '@shared/util/link'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'

const VerifyingEmail: PageWithContext = observer(() => {
    const router = useRouter()
    const {
        query: { code },
    } = useRouter()

    const { emailVerificationStore } = useSession()

    useNavigation({
        action: 'HELP_CENTER',
        showLinks: false,
    })

    useEffectAsync(async () => {
        if (localStorage.getItem('isOnboarding') === 'lending') {
            localStorage.removeItem('isOnboarding')
            router.push(`${URLS.EMAIL_VERIFICATION}?code=${code}`)
            return
        }
        if (typeof code !== 'string') {
            throw new RedirectError(
                LINK.verifySSOResult(SsoType.Email, 'failed'),
            )
        }

        if (!emailVerificationStore) {
            throw new RedirectError(
                LINK.verifySSOResult(SsoType.Email, 'failed'),
            )
        }

        const { status } =
            await emailVerificationStore.completeVerification(code)

        if (status !== OtpVerificationStatus.SUCCESS) {
            throw new RedirectError(
                LINK.verifySSOResult(SsoType.Email, 'failed', code),
            )
        }
    }, [code])

    return <PageTemplate {...PAGE_OPTIONS.SSO_EMAIL_VERIFYING} />
})

VerifyingEmail.getLayout = getAuthLayout(true)

export default VerifyingEmail
